import CreateObjectiveDialog from './CreateObjectiveDialog';

export default CreateObjectiveDialog;
